export default __webpack_public_path__ + "static/media/daewha.7f9a671e.jpg";